import { render, staticRenderFns } from "./ProjectPointDetail.vue?vue&type=template&id=d6b6839a&scoped=true&"
import script from "./ProjectPointDetail.vue?vue&type=script&lang=js&"
export * from "./ProjectPointDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPointDetail.vue?vue&type=style&index=0&id=d6b6839a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b6839a",
  null
  
)

export default component.exports